<template>
    <div class="grid">
        <div class="col-12">
            <div class="card" v-if="permission?.includes('read')">
                <Toast />
                <Error :errors="errors" />

                <Fieldset legend="Filter" :toggleable="true" :collapsed="true" class="mb-3">
                    <Filter @submit="getDataTable()" ref="filter" />
                </Fieldset>

                <Fieldset legend="Import" :toggleable="true" :collapsed="true" class="mb-3"
                    v-if="permission.includes('create')">
                    <Import @submit="getDataTable()" ref="import" />
                </Fieldset>

                <DataTable :value="dataTable" responsiveLayout="scroll" :loading="loading" dataKey="number"
                    @sort="onSort($event)" :resizableColumns="true">
                    <template #header>
                        <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
                            <div>
                                <Button :loading="loadingExcel" label="Export Excel" icon="pi pi-file-excel"
                                    class="p-button p-button-success mr-2 my-1 inline-block"
                                    @click="exportExcelCSV('xlsx')" />
                                <Button :loading="loadingCsv" label="Export CSV" icon="pi pi-file-excel"
                                    class="p-button p-button-success mr-2 my-1 inline-block"
                                    @click="exportExcelCSV('csv')" />
                            </div>
                            <span class="block mt-2 md:mt-0 p-input-icon-left">
                                <i class="pi pi-search" />
                                <InputText v-model="search" placeholder="Cari..." @keyup.enter="getDataTable" />
                            </span>
                        </div>
                    </template>
                    <Column field="number" header="No." :style="{ width: '20px' }">
                        <template #body="slotProps">
                            {{ slotProps.data.number }}
                        </template>
                    </Column>
                    <Column field="region_name" header="Region">
                        <template #body="slotProps">
                            {{ slotProps.data.region_name }}
                        </template>
                    </Column>
                    <Column field="user_level" header="User Level">
                        <template #body="slotProps">
                            {{ slotProps.data.user_level }}
                        </template>
                    </Column>
                    <Column field="user_code" header="User Code">
                        <template #body="slotProps">
                            {{ slotProps.data.user_code }}
                        </template>
                    </Column>
                    <Column field="user_name" header="User Name">
                        <template #body="slotProps">
                            {{ slotProps.data.user_name }}
                        </template>
                    </Column>
                    <Column field="periode_label" header="Periode">
                        <template #body="slotProps">
                            {{ slotProps.data.periode_label }}
                        </template>
                    </Column>
                    <Column field="kpi_type" header="KPI">
                        <template #body="slotProps">
                            {{ slotProps.data.kpi_type }}
                        </template>
                    </Column>
                    <Column field="target_value" header="Target">
                        <template #body="slotProps">
                            {{ slotProps.data.target_value }}
                        </template>
                    </Column>
                    <Column header="Aksi" field="aksi">
                        <template #body="slotProps">
                            <Button v-if="permission.includes('update')" @click="editItem(slotProps.data)" icon="pi pi-pencil"
                                class="p-button-rounded p-button-success mr-2" />
                        </template>
                    </Column>


                    <template #empty> No data found. </template>
                    <template #loading> Loading data. Please wait. </template>
                    <template #footer>
                        In total there are {{ totalItemsCount ? totalItemsCount : 0 }} data.
                    </template>
                </DataTable>

                <Paginator v-model:rows="rows" v-model:first="offset" :totalRecords="totalItemsCount"
                    :rowsPerPageOptions="[10, 20, 30]">
                    <template>
                        {{ totalItemsCount }}
                    </template>
                </Paginator>

                <Dialog v-model:visible="editItemDialog" :style="{ width: '450px' }" header="Edit Target" :modal="true"
                    class="p-fluid">

                    <div class="field">
                        <label>Target</label>
                        <InputText v-model="item.target_value" required="true" autofocus
                            :class="{ 'p-invalid': errorAdd.target_value }" />
                        <small class="p-invalid" style="color: red" v-if="errorEdit.target_value">{{
                            errorEdit.target_value[0]
                            }}</small>
                    </div>
                    <template #footer>
                        <Button label="Batal" icon="pi pi-times" class="p-button-text" @click="hideDialog" />
                        <Button label="Simpan" icon="pi pi-check" class="p-button-text" @click="update"
                            :loading="loadingEditItem" />
                    </template>
                </Dialog>

            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import { numberingDatatable } from "../../utils/helpers";
import Error from "../../components/Error.vue";
import Import from "../../components/master/target-kpi/Import.vue";
import Filter from "../../components/master/target-kpi/Filter.vue";

export default {
    components: {
        Error: Error,
        Import: Import,
        Filter: Filter,
    },
    data() {
        return {
            // loading
            loading: false,
            loadingExcel: false,
            loadingCsv: false,
            loadingEditItem: false,

            //datatables
            data: null,
            dataTable: null,
            rows: 10,
            search: null,
            offset: null,
            field: null,
            sort: null,
            page: null,
            totalItemsCount: 0,

            // edit
            editItemDialog: false,
            item: {}
        };
    },
    mounted() {
        this.getDataTable();
        this.$store.commit("setErrors", {});
    },
    watch: {
        offset() {
            this.getDataTable();
        },
        rows() {
            this.getDataTable();
        },
    },
    computed: {
        ...mapGetters(['errors', 'errorEdit', 'errorAdd']),
        ...mapGetters("auth", ["permission"]),
    },
    methods: {
        formatDate(value) {
            if (value) {
                return moment.utc(value).format("DD-MM-YYYY");
            }
        },
        // DATATABLE
        getDataTable() {
            this.loading = true;

            if (this.$refs?.filter) {
                this.$refs.filter.loading = true;
            }

            this.page = this.offset / this.rows + 1;

            this.axios({
                method: "GET",
                url: process.env.VUE_APP_ROOT_API + "web/master-target-kpi",
                params: {
                    search: this.search,
                    per_page: this.rows,
                    page: this.page,
                    order_by: this.field,
                    sort_by: this.sort,
                    region_id: this.$refs?.filter?.filters.region_id,
                    user_code: this.$refs?.filter?.filters.user_code,
                    kpi_type: this.$refs?.filter?.filters.kpi_type,
                    periode_label: this.$refs?.filter?.filters.periode_label,
                },
            })
                .then((res) => {
                    this.data = res.data.data.data;
                    this.dataTable = numberingDatatable(
                        res.data.data.data,
                        this.page,
                        this.rows
                    );
                    this.totalItemsCount = res.data.data.total;
                    this.rows = parseInt(res.data.data.per_page);
                    this.loading = false;
                    this.$refs.filter.loading = false;
                })
                .catch((err) => {
                    console.log(err);
                    this.loading = false;
                    this.$refs.filter.loading = false;

                });
        },
        onSort(event) {
            this.field = event.sortField;
            this.sort = event.sortOrder == "1" ? "ASC" : "DESC";
            this.getDataTable();
        },
        // EXPORT
        exportExcelCSV(ext) {
            if (ext == "xlsx") {
                this.loadingExcel = true;
            } else if (ext == "csv") {
                this.loadingCsv = true;
            }

            this.axios({
                method: "GET",
                url: process.env.VUE_APP_ROOT_API + "web/master-target-kpi/export",
                responseType: "blob",
                params: {
                    ext: ext,
                    region_id: this.$refs?.filter?.filters.region_id,
                    user_code: this.$refs?.filter?.filters.user_code,
                    kpi_type: this.$refs?.filter?.filters.kpi_type,
                    periode_label: this.$refs?.filter?.filters.periode_label,
                },
            })
                .then((response) => {
                    let fileUrl = window.URL.createObjectURL(response.data);
                    let fileLink = document.createElement("a");

                    fileLink.href = fileUrl;

                    fileLink.setAttribute("download", "Master Target KPI Export." + ext);

                    document.body.appendChild(fileLink);

                    fileLink.click();

                    if (ext == "xlsx") {
                        this.loadingExcel = false;
                    } else if (ext == "csv") {
                        this.loadingCsv = false;
                    }
                })
                .catch((err) => {
                    console.log(err);

                    if (ext == "xlsx") {
                        this.loadingExcel = false;
                    } else if (ext == "csv") {
                        this.loadingCsv = false;
                    }
                });
            // EDIT
        },

        // EDIT
        editItem(item) {
            this.item = item;


            this.editItemDialog = true;
            this.$store.commit('setErrorEdit', {});

        },
        hideDialog() {
            this.editItemDialog = false;
            this.submitted = false;
        },
        update() {
            this.loadingEditItem = true;

            this.axios({
                method: 'POST',
                url: process.env.VUE_APP_ROOT_API + 'web/master-target-kpi/update',
                data: {
                    "target_id": this.item.target_id,
                    "target_value": this.item.target_value,
                },
            })
                .then((res) => {
                    this.loadingEditItem = false;
                    if (res) {
                        this.$toast.add({ severity: 'success', summary: 'Successful', detail: 'Data Berhasil Diupdate', life: 3000, });
                        this.$store.commit('setErrors', {});
                        this.$store.commit('setErrorEdit', {});
                        this.item = {};
                        this.editItemDialog = false;
                        this.getDataTable();
                    }
                })
                .catch((err) => {
                    console.log(err);
                    this.loadingEditItem = false;
                    this.$store.commit('setErrorEdit', err.response.data.data);
                    this.$toast.add({ severity: 'error', summary: 'Failed', detail: 'Data Gagal Diperbarui', life: 3000, });
                });
        },
    },
};
</script>
